export default __webpack_public_path__ + "static/media/up-arrow.36d80948.svg";